import { render } from "./DistributorEdit.vue?vue&type=template&id=3d4dd1ab&scoped=true"
import script from "./DistributorEdit.js?vue&type=script&lang=js&external"
export * from "./DistributorEdit.js?vue&type=script&lang=js&external"

import "./DistributorEdit.scss?vue&type=style&index=0&id=3d4dd1ab&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d4dd1ab"]])

export default __exports__